// extracted by mini-css-extract-plugin
export default {"container":"style_container__Kku-M","comment":"style_comment__0SWLt","success":"style_success__+RKmq","fail":"style_fail__rUUKI"};